import { ComponentPropsWithoutRef, MouseEventHandler } from "react";
import IntervalActionButton from "../interval-action-button";
import { ReactComponent as OutlinePlus } from "assets/svg/outline-plus.svg";

type Props = Omit<
  ComponentPropsWithoutRef<typeof IntervalActionButton>,
  "color" | "Icon"
> & { onClick: MouseEventHandler };
const AddTimeslot = (props: Props) => (
  <IntervalActionButton {...props} Icon={OutlinePlus} />
);

export default AddTimeslot;
